// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~styles/colors.module.css'","NEUTRAL_GRAY_400":"#94A3B8","NEUTRAL_GRAY_600":"#475569","labelRoot":"styles_labelRoot__fKJIB","disabled":"styles_disabled__x0lvI"};